/* SG Med in-cart variant switching — scoped by snippet to two products. */
(function () {
  'use strict';
  var busy = false;
  function route(key, fallback) { return (window.routes && window.routes[key]) || fallback; }
  async function shopify(url, body) {
    var init = {credentials:'same-origin', headers:{Accept:'application/json'}};
    if (body !== undefined) {
      init.method='POST';
      init.headers['Content-Type']='application/json';
      init.body=JSON.stringify(body);
    }
    var response=await fetch(url,init);
    var data={};
    try { data=await response.json(); } catch (_) {}
    if (!response.ok) throw new Error(data.description || data.message || 'Shopify cart update failed.');
    return data;
  }
  document.addEventListener('change',async function (event) {
    var el=event.target && event.target.closest && event.target.closest('[data-sgmed-cart-variant]');
    if (!el || busy) return;
    var from=String(el.dataset.originalVariant),to=String(el.value);
    if (from===to) return;
    var status=el.parentElement.querySelector('.sgmed-variant-switch-status');
    var cart=route('cartUrl','/cart');
    var added=false,removed=false;
    busy=true;el.disabled=true;
    if(status) status.textContent='Updating option…';
    try {
      if (!/^\d+$/.test(from) || !/^\d+$/.test(to)) throw new Error('Invalid option. Refresh the cart.');
      var before=await shopify(cart+'.js');
      var source=before.items.find(function (item) {return item.key===el.dataset.originalKey;});
      if (!source || String(source.variant_id)!==from) throw new Error('Cart changed. Refresh and try again.');
      if (source.selling_plan_allocation || source.properties && Object.keys(source.properties).length) throw new Error('Please update this item on its product page.');
      if (before.items.filter(function (item) {return String(item.variant_id)===from;}).length!==1) throw new Error('Multiple lines for this item. Please update on its product page.');
      var qty=Number(source.quantity);
      if (!Number.isSafeInteger(qty) || qty<1) throw new Error('Invalid quantity. Refresh the cart.');
      // Preserve existing line if inventory validation rejects the new option.
      await shopify(route('cartAddUrl','/cart/add')+'.js',{items:[{id:Number(to),quantity:qty}]});
      added=true;
      var middle=await shopify(cart+'.js');
      var original=middle.items.find(function (item) {return item.key===source.key;});
      if (!original) {
        var candidates=middle.items.filter(function (item) {return String(item.variant_id)===from;});
        if (candidates.length===1) original=candidates[0];
      }
      if (!original || Number(original.quantity)!==qty) throw new Error('Original cart line changed while updating.');
      await shopify(route('cartChangeUrl','/cart/change')+'.js',{id:original.key,quantity:0});
      removed=true;
      var after=await shopify(cart+'.js');
      var total=after.items.filter(function (item) {return String(item.variant_id)===to;}).reduce(function (n,item) {return n+Number(item.quantity);},0);
      if (total<qty) throw new Error('Replacement item could not be confirmed.');
      window.location.assign(cart);
    } catch (err) {
      el.value=from;
      if (status) {
        status.textContent=(added&&!removed?'The replacement may have been added without removing the original. Review cart before checkout.':err.message || 'Unable to update cart.')+' ';
        var link=document.createElement('a');
        link.href=cart;link.textContent='Review cart';link.style.textDecoration='underline';
        status.appendChild(link);
      }
      console.error('SGMED variant switch',err);
    } finally {
      el.disabled=false;busy=false;
    }
  });
}());